<template>
  <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      max-width="290px"
      min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
          :label="labelName"
          readonly
          v-on="on"
          clearable
          @click:clear="clear()"
          :value="dateValue | dateFormat"
          prepend-icon="mdi-calendar"
      >
        <v-icon color="#3577BE"></v-icon>
      </v-text-field>
    </template>

    <v-date-picker
        no-title
        scrollable
        locale="ru-RU"
        v-model="dateValueLocal"
        :active-picker.sync="activePicker"
        @input="onInput"
    />
  </v-menu>
</template>

<script>
export default {
  name: "DateField",
  props: ['dateValue', 'labelName'],
  data() {
    return {
      menu: false,
      activePicker: 'DATE',
      dateValueLocal: this.dateValue
    }
  },
  watch: {
    dateValue(val) {
      this.dateValueLocal = val || null;
    }
  },
  filters: {
    dateFormat(date) {
      if (!date) return '';
      const mdate = new Date(date);
      const options = { timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric' };
      return mdate.toLocaleDateString('ru-RU', options);
    },
  },
  methods: {
    onInput(val) {
      if (this.activePicker !== 'DATE') {
        this.activePicker = 'DATE';
        return;
      }
      this.$emit('minput', val);
      this.menu = false;
    },

    clear() {
      this.$emit('minput', null);
      this.dateValueLocal = null;
    }
  }
}
</script>

<style scoped lang="scss">
.v-input__append-inner {
  margin-top: 14px !important;
}
</style>